import React from 'react';
import { useUser } from '@lore/auth';
import { Helmet } from 'react-helmet-async';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';
import useRouter from '../../../hooks/useRouter';
import useSetupNavigation from '../useSetupNavigation';

export default function Layout(props) {
  const { history } = useRouter();
  const user = useUser();

  const navigation = useSetupNavigation(Urls.MOTIVATION);

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Motivation</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls.INTERESTS)}
        onNext={(newData) => history.push(Urls.CONTACT)}
        onSkip={() => history.push(Urls.CONTACT)}
      />
    </ParentLayout>
  );
};
